























import Vue from 'vue';
import Component from 'vue-class-component';
import { Inject } from 'vue-property-decorator';
import { Authentication } from './Authentication';

@Component
export default class Login extends Vue {
  private email = '';
  private password = '';
  private error = '';
  @Inject('authenticationService')
  private readonly authenticationService!: Authentication;

  private get hasError(): boolean {
    return this.error.length > 0;
  }

  private async login() {
    try {
      await this.authenticationService.signIn(this.email, this.password);
      this.$router.replace('/home');
    } catch (e) {
      this.error = e.message;
    }
  }
}
